import { useEffect, useRef } from "react";
import styles from "./index.module.css";
const AtSecondSight = (props) => {
  const svgRef = useRef(null);

  return (
    <svg
      ref={svgRef}
      width="1206"
      height="185"
      viewBox="0 0 1206 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${styles.svg} ${props.className}`}
    >
      <path
        d="M66.3555 136.025C92.9243 117.131 182.668 32.1114 216.912 2C193.295 35.654 107.094 163.184 98.8284 182.668"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`417.537px`
        }}
      />
      <path
        d="M2 99.4191C28.5688 97.6478 146.652 89.382 176.173 90.5628"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`174.434px`
        }}
      />
      <path
        d="M198.019 45.1006C223.407 42.7389 300.161 46.2814 322.597 42.7389"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`124.663px`
        }}
      />
      <path
        d="M252.928 19.1223C236.448 40.1796 151.966 159.642 239.348 98.8287"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`153.027px`
        }}
      />

      <path
        d="M418.245 84.659C427.101 75.8028 467.971 37.8106 441.271 28.5688C414.571 19.3271 353.089 39.7869 377.506 77.5736C399.252 111.227 429.463 153.737 377.506 160.822C347.596 164.901 318.464 148.424 306.065 137.796C281.747 116.953 297.799 95.8765 341.49 105.914"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`437.718px`
        }}
      />
      <path
        d="M898.398 84.659C907.255 75.8028 948.124 37.8106 921.425 28.5688C894.725 19.3271 833.243 39.7869 857.66 77.5736C879.406 111.227 909.616 153.737 857.66 160.822C827.75 164.901 798.618 148.424 786.219 137.796C761.9 116.953 777.953 95.8765 821.644 105.914"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`437.719px`
        }}
      />
      <path
        d="M953.163 61.6323L949.621 67.5365"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`6.88518px`
        }}
      />
      <path
        d="M941.355 78.164C938.403 82.8874 908.291 124.217 955.525 100.009C964.381 95.4707 955.525 83.4778 990.95 80.5257C980.913 81.7833 962.019 82.8874 960.248 97.0574C958.92 107.685 985.636 84.6586 993.902 78.164C986.226 97.6478 968.033 142.486 928.956 161.413C891.169 179.716 866.962 147.833 1022.83 98.8287C1041.33 71.079 1071.25 20.3031 1084.24 6.72348C1062.98 29.7498 1014.57 110.637 1012.8 118.903C1011.02 127.169 1070.07 52.7761 1058.85 97.6478C1054.71 114.18 1068.88 106.504 1084.83 96.467C1094.86 72.2599 1130.29 23.8456 1133.83 19.1223C1118.48 39.5901 1032.28 160.232 1121.43 97.6478"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`1063.36px`
        }}
      />
      <path
        d="M1080.1 45.1006C1092.5 45.1006 1173.98 47.4623 1203.5 42.7389"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`123.519px`
        }}
      />
      <path
        d="M450.394 95.2853C450.414 95.2863 450.434 95.2873 450.454 95.2883M450.454 95.2883C473.759 96.4416 482.585 82.2972 464.297 84.6572C458.506 85.4046 452.649 90.3387 450.454 95.2883ZM450.454 95.2883C441.816 114.767 489.685 102.371 497.36 97.0574C512.121 77.5736 527.472 74.6215 526.882 88.2011C527.472 68.1269 499.231 88.9327 497.36 99.4191C494.696 114.358 532.574 103.936 548.727 93.5145C536.919 106.504 541.437 123.959 557.583 105.913C559.872 103.356 561.841 100.995 563.523 98.8236M563.523 98.8236C583.97 72.4176 561.126 74.0311 551.089 91.1529C548.257 95.9837 554.208 98.9561 563.523 98.8236ZM563.523 98.8236C574.296 98.6703 591.237 101.19 601.274 82.2969C599.503 83.6746 590.176 99.8091 584.742 108.866C579.429 117.722 634.928 65.7652 623.12 100.009C614.162 125.988 636.109 108.866 654.412 100.009C662.507 96.0925 665.63 88.7915 686.885 84.0682C636.699 95.2205 656.774 141.339 718.177 42.7392C690.427 89.9724 624.891 190.934 719.948 98.8236"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`880.984px`
        }}
      />
    </svg>
  );
};

export default AtSecondSight;
